import { render } from "./CompanyBillingHistoryDetails.vue?vue&type=template&id=02438159"
import script from "./CompanyBillingHistoryDetails.vue?vue&type=script&lang=js"
export * from "./CompanyBillingHistoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__